module.exports = __webpack_public_path__ + "7e9051a600b2b65709fc1422b6265da6.png";